import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { useTranslation } from 'react-i18next';

const OfferListEmptyState = ({
  handleCreateOffer
}: {
  handleCreateOffer: () => void;
}) => {
  const { t } = useTranslation(['events']);

  return (
    <div className="pt-[36x] md:pt-[90px] -mt-[36px] pb-20 md:w-[630px] md:mx-auto md:px-0 px-4">
      <div className="flex items-center justify-center h-full">
        <div className="bg-white p-4 rounded-lg shadow-md w-full px-20 py-10">
          <div className="flex items-center justify-center">
            <img src="/img/events/create/offer.svg" height={32} width={32} />
          </div>
          <div className="font-bold text-base text-[#575757] text-center mt-2">
            {t('settings.promoterOffers.page.emptyState.title')}
          </div>
          <p className="text-sm text-[#575757] text-center mt-2">
            {t('settings.promoterOffers.page.emptyState.description')}
          </p>
          <div className="mt-4">
            <Button type={ButtonType.Primary} onClick={handleCreateOffer}>
              {t('settings.promoterOffers.page.emptyState.createOffer')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferListEmptyState;
